<template>
  <transition name="fade">
    <keep-alive>
      <meta name="referrer" content="no-referrer"> <!-- 解决微信图片授权问题-->
      <!-- 路由出口,路由匹配到的组件将渲染在这里 -->
      <router-view></router-view>
    </keep-alive>
  </transition>
</template>

<script>
export default {
  name: "app",
  mounted: function() {
    //关闭时清空currentTag、openedTags;刷新时不处理
    window.onload = function() {
      if (!window.sessionStorage["tempFlag"]) {
        localStorage.removeItem("currentTag");
        localStorage.removeItem("openedTags");
        location.reload(); //不能省，强制跳到登陆页
      } else {
        window.sessionStorage.removeItem("tempFlag");
      }
    };
    window.onunload = function() {
      window.sessionStorage["tempFlag"] = true;
    };
    window.onbeforeunload = function() {
      sessionStorage.setItem("tempFlag", true);
    };

  }
};
</script>


<style>
html,
body {
  height: 100%;
  width: 100%;
}
#app {
  height: 100%;
  width: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 16px;
  color: #2c3e50;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
</style>



// WEBPACK FOOTER //
// App.vue?297a233d